
const images = {
  knowledgeSection: {
    frontend: require("./astronaut.png"),
  },
  certifications: {
    openwebinars: require("./openwebinars.png"),
    udemy: require("./udemy.png"),
    wesbos: require("./wesbos.png"),
    youtube: require("./youtube.png"),
    sergioAlonso: require("./sergio_alonso.png"),
    fp: require("./fp.png"),
  },
  companies: {
    singularFactory: require("./singularFactory.webp"),
    hologis : require('./hologis.png'),
    cargobot : require('./cargobot.png'),
    diktados : require('./diktados.png')
  },
};

export default images;
